import { render, staticRenderFns } from "./DetailTitleBar.vue?vue&type=template&id=e492534c&"
import script from "./DetailTitleBar.vue?vue&type=script&lang=js&"
export * from "./DetailTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports